import { keepPreviousData } from '@tanstack/react-query';
import { MENU_MOCK_MODE, mockMenuCategories } from '../data/mockMenu';
import { ordersApi } from '../services/ordersApi';

export const menuQueryKey = ['orders', 'menu'] as const;
export const dineInMenuQueryKey = ['orders', 'menu', 'dine-in'] as const;

/** Меню приложения (доставка / самовывоз) */
export function menuQueryOptions() {
  return {
    queryKey: menuQueryKey,
    queryFn: () =>
      MENU_MOCK_MODE ? Promise.resolve(mockMenuCategories) : ordersApi.getMenu('delivery'),
    staleTime: MENU_MOCK_MODE ? Infinity : 5 * 60_000,
    gcTime: 1000 * 60 * 30,
    placeholderData: keepPreviousData,
  };
}

/** Меню зала на /menu */
export function dineInMenuQueryOptions() {
  return {
    queryKey: dineInMenuQueryKey,
    queryFn: () =>
      MENU_MOCK_MODE ? Promise.resolve(mockMenuCategories) : ordersApi.getMenu('dine-in'),
    staleTime: MENU_MOCK_MODE ? Infinity : 5 * 60_000,
    gcTime: 1000 * 60 * 30,
    placeholderData: keepPreviousData,
  };
}
